import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  footerPlatformTitle: {
    id: 'catalog.footer.platform.title',
    defaultMessage: 'Platform',
    description: 'Footer column title for platform links.',
  },
  footerPlatformExploreCourses: {
    id: 'catalog.footer.platform.explore-courses',
    defaultMessage: 'Explore courses',
    description: 'Footer link label for exploring courses.',
  },
  footerResourcesTitle: {
    id: 'catalog.footer.resources.title',
    defaultMessage: 'Resources',
    description: 'Footer column title for resource links.',
  },
  footerResourcesAbout: {
    id: 'catalog.footer.resources.about',
    defaultMessage: 'About',
    description: 'Footer link label for about page placeholder.',
  },
  footerResourcesFaq: {
    id: 'catalog.footer.resources.faq',
    defaultMessage: 'FAQ',
    description: 'Footer link label for the FAQ page.',
  },
  footerResourcesHelp: {
    id: 'catalog.footer.resources.help',
    defaultMessage: 'Help center',
    description: 'Footer link label for help center placeholder.',
  },
  footerLegalTitle: {
    id: 'catalog.footer.legal.title',
    defaultMessage: 'Legal',
    description: 'Footer column title for legal links.',
  },
  footerLegalTerms: {
    id: 'catalog.footer.legal.terms',
    defaultMessage: 'Terms',
    description: 'Footer link label for terms placeholder.',
  },
  footerLegalPrivacy: {
    id: 'catalog.footer.legal.privacy',
    defaultMessage: 'Privacy policy',
    description: 'Footer link label for privacy placeholder.',
  },
  footerSummary: {
    id: 'catalog.footer.summary',
    defaultMessage: 'A premium education platform designed for excellence and precision.',
    description: 'Footer brand summary text.',
  },
  footerCopyright: {
    id: 'catalog.footer.copyright',
    defaultMessage: '© {year} WutiSkill Inc. All rights reserved.',
    description: 'Footer copyright notice.',
  },
  footerSocialTwitter: {
    id: 'catalog.footer.social.twitter',
    defaultMessage: 'Twitter',
    description: 'Footer social link label for Twitter.',
  },
  footerSocialLinkedIn: {
    id: 'catalog.footer.social.linkedin',
    defaultMessage: 'LinkedIn',
    description: 'Footer social link label for LinkedIn.',
  },
});

export default messages;
